import Radio  from 'backbone.radio';
import _ from 'underscore';
import Handlebars from 'handlebars';
import Marionette from 'backbone.marionette';
import CollectionTable from '@/views/collection_table';
import DeviceGroupItemTemplate from '@/../templates/device-group-item-selectable.hbs';
import ProductDeploymentItemView from '@/views/product_deployment_item';
import latest_deployment_template from '@/../templates/product-deployment-item-short.hbs';
import strings_common from 'amdi18n-loader!@/nls/common';
import strings_specific from 'amdi18n-loader!@/nls/dialogs';

    var ChildView = Marionette.View.extend({
        template: Handlebars.compile(DeviceGroupItemTemplate),
        templateContext: function(){
            var regions = Radio.request('api', 'cloud_regions');
            var show_regions = regions && regions.length;
            return {
                region: this.model.get('region') || 'Default',
                show_select: true,
                show_name: true,
                show_region: show_regions,
                show_deployment: true,
            };
        },
        tagName: 'tr',
        events: {
            'click': 'chooseItem'
        },
        regions: {
            deployment_region: '.deployed-build',
        },
        initialize: function(){
            _.bindAll(this, 'render_deployment_device_info');
        },
        render_deployment_device_info: function () {
            var deployment_info_view;
            var current_deployment = this.model.rel.get('current_deployment');

            if ( !current_deployment ) return;

            deployment_info_view = new ProductDeploymentItemView({
                model: current_deployment,
                template: Handlebars.compile(latest_deployment_template),
                can_view_code: false,
            });

            this.showChildView('deployment_region', deployment_info_view);
        },
        chooseItem: function () {
            this.$el.find('input[name=devicegroups-radio]').prop('checked', true);
            this.triggerMethod('choose:devicegroup', this.model);
        },
        onRender: function(){
            var current_target = this.options.collection_table_view.options.current_target;
            // Is this the selected devicegroup?
            this.$el.val(this.model.id);
            if ( current_target && this.model.id === current_target.id ){
                this.$el.find('input[name=devicegroups-radio]').prop('checked', true);
                this.$el.addClass('selected');
            }

            // Render the Deployment Info
            // Set up a listener for the current deployment relationship
            this.listenTo(this.model.rel, 'change:current_deployment', this.render_deployment_device_info);
            var current_deployment = this.model.rel.get('current_deployment');
            // Render Current Deployment
            if ( current_deployment && !current_deployment.rel.get('devicegroup') ) {
                current_deployment.fetch().then(this.render_deployment_device_info);
            } else {
                this.render_deployment_device_info();
            }
        },
    });

    var devicegroup_list = CollectionTable.extend({
        initialize: function(options){
            var current_target;
            if ( options.devicegroup ){
                current_target = options.devicegroup;
            } else {
                current_target = null;
            }

            var strings = _.extend({}, strings_common, strings_specific);
            options.columns = _.compact([
                this.getOption('columns').indexOf('select') > -1 &&
                {
                    name: strings.select,
                    class_name: 'select',
                }, this.getOption('columns').indexOf('name') > -1 &&
                {
                    name: strings.name,
                    class_name: 'name',
                    sortable: false,
                    sort_by: 'name',
                }, this.getOption('columns').indexOf('region') > -1 &&
                {
                    name: 'Region',
                    class_name: 'region',
                    sortable: false,
                    sort_by: 'region',
                }, this.getOption('columns').indexOf('last_updated') > -1 &&
                {
                    name: 'Last Updated',
                    class_name: 'last-updated',
                    sortable: false,
                    sort_by: 'last_updated',
                }, this.getOption('columns').indexOf('deployment') > -1 &&
                {
                    name: strings.deployment,
                    class_name: 'deployment',
                    sortable: false,
                    sort_by: 'name',
                }
            ]);
            options.secondary_sort = 'name';
            options.default_sort_desc = true;
            options.default_sort_column = 1;
            options.current_target = current_target;
            CollectionTable.prototype.initialize.call(this, options);
        },
        childView: ChildView,
        class_name: 'products-list',
        filter: function (devicegroup) {
            var product = devicegroup.rel.get('product');
            var type = this.options.type || 'development_devicegroup';
            var is_same_product = product && product.id === this.getOption('product').id;
            var is_correct_type = devicegroup.type === type;

            return is_same_product && is_correct_type;
        }
    });

    export default devicegroup_list;



